export const LinkConfigAll: any = {
    us: {
        variantId: '41654228713545',
        itemA1: 'https://us.ecoflow.com/products/river-3-waterproof-bag?variant=41654228713545',
        itemA2: 'https://www.amazon.com/dp/B0DB1S36YP?maas=maas_adg_859899EB00F83EC5F048FAD373EDAAE2_afap_abs&ref_=aa_maas&tag=maas',
    },
    ca: {
        variantId: '45168753672346',
        itemA1: 'https://ca.ecoflow.com/products/river-3-waterproof-bag?variant=45168753672346',
        itemA2: 'https://www.amazon.ca/dp/B0DB4Y5VVT?maas=maas_adg_BD62BF62E23DAD18843AEEF45FE02ABE_afap_abs&ref_=aa_maas&tag=maas',
    },
};
